import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import { Row } from '@cuemath/comps';

import styled from 'styled-components';

import FilterDropdown from 'comps/filter/filter-dropdown';
import { IconButton, LinkButton } from 'modules/list';
import { getOptions } from 'modules/form';
import { FORM_ACTIONS } from 'constants/form';
import { USER_CONFIG, BATCHES_CONFIG } from 'constants/api';

import ViewIcon from 'img/view.png';
import EditIcon from 'img/edit.png';

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  padding-left: 20px;
  padding-right: 20px;
`;

const LinkNav = styled(Link)`
  text-decoration: underline;
  cursor: pointer;
  color: blue;
  text-align: center;
  &:hover {
    color: blue;
  }
  &:active {
    color: blue;
  }
`;

export const demoOptions = [
  {
    label: 'True',
    value: true,
  },
  {
    label: 'False',
    value: false,
  },
];

class StudentList extends PureComponent {
  onFilteredChange = filters => {
    this.props.onFilter(filters);
  };

  render() {
    const { students, openStudentForm, userConfig, programs, onCreateDemo } = this.props;

    let gradeOptions = [];
    let stateOptions = [];

    if (userConfig && programs) {
      gradeOptions = getOptions({ field: 'grade', userConfig, programs });
      stateOptions = getOptions({ field: 'studentState', userConfig, programs });
    }

    const tableColumns = [
      {
        Header: `Training Accounts`,
        columns: [
          {
            Header: '',
            accessor: 'name',
            Cell: row => {
              return (
                <Row justifyContent="space-around">
                  <IconButton
                    icon={ViewIcon}
                    onClick={() =>
                      openStudentForm({
                        formType: FORM_ACTIONS.VIEW,
                        data: row.original,
                      })
                    }
                  />
                  <IconButton
                    icon={EditIcon}
                    onClick={() =>
                      openStudentForm({
                        formType: FORM_ACTIONS.EDIT,
                        data: row.original,
                      })
                    }
                  />
                </Row>
              );
            },
          },
          {
            Header: 'Name',
            accessor: 'name',
            Cell: row => {
              return (
                <LinkNav
                  target="_blank"
                  to={{
                    pathname: `/student-form/${row.original.id}`,
                    state: {
                      formType: FORM_ACTIONS.CREATE,
                      student: row.original,
                    },
                  }}
                >
                  {row.original.name}
                </LinkNav>
              );
            },
          },
          {
            Header: 'Grade',
            accessor: 'grade',
            width: 100,
            fixed: 'top',
            filterable: true,
            Filter: ({ filter, onChange }) => {
              return (
                <FilterDropdown
                  options_list={gradeOptions}
                  filter={filter}
                  onChange={onChange}
                  multiple={true}
                />
              );
            },
          },
          {
            Header: 'State',
            accessor: 'state',
            width: 100,
            filterable: true,
            Filter: ({ filter, onChange }) => {
              return (
                <FilterDropdown
                  options_list={stateOptions}
                  filter={filter}
                  onChange={onChange}
                  multiple={true}
                />
              );
            },
          },
          {
            Header: 'Test Account',
            accessor: 'is_demo',
            width: 100,
            Cell: ({ value }) => (value ? 'True' : 'False'),
            filterable: true,
            Filter: ({ filter, onChange }) => {
              return (
                <FilterDropdown
                  options_list={demoOptions}
                  filter={filter}
                  onChange={onChange}
                  multiple={false}
                />
              );
            },
          },
          {
            Header: 'Demo Slot',
            accessor: 'id',
            Cell: row => {
              return (
                <LinkButton
                  text="Create Demo Slot"
                  onClick={() => onCreateDemo(row.original.id)}
                />
              );
            },
          },
        ],
      },
    ];
    return (
      <React.Fragment>
        <TableWrapper>
          <ReactTable
            data={students}
            className="-striped -highlight"
            manual
            showPaginationTop
            showPageSizeOptions={false}
            filterable={false}
            sortable={false}
            resizable={false}
            defaultPageSize={20}
            onFilteredChange={this.onFilteredChange}
            defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
            columns={tableColumns}
            style={{ textAlign: 'center' }}
          />
        </TableWrapper>
      </React.Fragment>
    );
  }
}

export default connect(
  ({ configs, programs }) => ({
    userConfig: store.get(configs, USER_CONFIG),
    batchConfig: store.get(configs, BATCHES_CONFIG),
    programs: store.getAll(programs),
  }),
  null,
)(StudentList);
